import { getTelegramUserId } from "@/shared/lib/telegram"
import { detectPlatform } from "./detect"
import { getDeviceId } from "./device"

export interface PlatformIdentity {
	device_id?: string
	tg_user_id?: string
}

export interface PlatformIdentityOptions {
	/**
	 * Брать ли `device_id` в браузере.
	 *   `false` (по умолчанию) — поведение email-login/verification: browser → пусто.
	 *   `true` — поведение онбординга: browser тоже получает `device_id`.
	 */
	browserDeviceId?: boolean
}

/**
 * Идентификатор юзера для запросов без JWT (регистрация / логин / верификация /
 * онбординг). Бэкенду нужно понять, кто это, пока токена ещё нет:
 *  - Telegram → `tg_user_id` из SDK
 *  - Android / iOS → `device_id` (Capacitor Device.getId)
 *  - Browser → зависит от `options.browserDeviceId` (см. выше)
 */
export async function getPlatformIdentity({
	browserDeviceId = false,
}: PlatformIdentityOptions = {}): Promise<PlatformIdentity> {
	const platform = detectPlatform()

	if (platform === "telegram") {
		const tgUserId = getTelegramUserId()
		if (tgUserId === null) return {}
		return { tg_user_id: tgUserId }
	}

	if (platform === "android" || platform === "ios" || browserDeviceId) {
		return { device_id: await getDeviceId() }
	}

	return {}
}
